// extracted by mini-css-extract-plugin
export var attribution = "TestimonialGroup-module--attribution--28542";
export var cardGrid = "TestimonialGroup-module--card-grid--cc05b";
export var logo = "TestimonialGroup-module--logo--7be24";
export var quoteContainer = "TestimonialGroup-module--quote-container--ac008";
export var section = "TestimonialGroup-module--section--27ce8";
export var threeColumn = "TestimonialGroup-module--three-column--c69b4";